import { ServerErrorDefaultProps } from '../SessionOutcome/ServerErrorDefaultProps';

export const SessionInvalidDefaultProps = {
  ...ServerErrorDefaultProps,
  icon: 'cancel',
  title: 'Your session is no longer valid',
} as const;
